// store/index.js
import Vue from "vue";
import Vuex from "vuex";
import { updateField } from "vuex-map-fields";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    videos: [],
  },
  mutations: {
    updateField,
  },
});
